import { memo } from 'react'
import LoopIcon from '@mui/icons-material/Loop'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

interface LoopNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function LoopNode(props: LoopNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={<LoopIcon fontSize="small" />}
      showTargetHandle={true}
      showSourceHandle={true}
      sourceHandleCount={2}
    />
  )
}

export default memo(LoopNode)
